import gql from 'graphql-tag'

export const SEND_PNL_MAIL = gql`
mutation plChangeMail($data: [PlChangeWhereUserInput]){
  plChangeMail(data: $data)
}
`
